var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8.05957,
    width: 1.5,
    height: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 2.05957,
    width: 1.5,
    height: 13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10.0596,
    width: 1.5,
    height: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6.05957,
    width: 1.5,
    height: 9
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLikes);
export default __webpack_public_path__ + "static/media/twitterLikes.6885d577.svg";
export { ForwardRef as ReactComponent };